<template>
    <div :id="'chart-container' + index">
      <canvas :id="'myChart' + index" width="10" :height="this.height"></canvas>
    </div>
</template>
<script>
import Chart from 'chart.js'
import 'chartjs-plugin-datalabels'
export default {
  name: 'BarChart',
  data () {
    return {
      ctx: '',
      myChart: '',
      host: ''
    }
  },
  created () {
    this.host = window.location.hostname
    this.host = this.host.substring(0, this.host.indexOf('.'))
  },
  computed: {
    height () {
      if (this.data && this.data.labels) {
        if (this.numberOfBars) {
          return this.numberOfBars
        } else {
          return this.data.labels.length + 1
        }
      } else {
        return 0
      }
    }
  },
  props: {
    data: { type: Object, required: true },
    index: { type: String },
    isNotStacked: { type: Boolean },
    maxValue: {type: Number},
    hideTotal: {type: Boolean}
  },
  watch: {
    data: function (val) {
      this.initChart(
        this.prepareData(val)
      )
    }
  },
  mounted () {
    Chart.defaults.global.plugins.datalabels.anchor = 'end'
    Chart.defaults.global.plugins.datalabels.align = 'end'
    Chart.defaults.global.legend.display = false
    this.initChart(this.prepareData(this.data))
  },
  methods: {
    clickFunction (point, event) {
      const item = event[0]
      if (!item) return
      this.$emit('click', this.data.results[item._index])
    },
    getColor (label) {
      if (this.host === 'vforwarding') {
        return 'rgba(45, 81, 141, 0.6)'
      } else {
        switch (label) {
          case 'alerted':
          case 'max':
            return 'rgba(221, 8, 50, 0.6)'
          case 'delayed':
          case 'min':
            return 'rgba(255, 208, 40, 0.6)'
          case 'waiting for pickup':
            return 'rgba(255, 230, 0, 0.7)'
          case 'land transport to POL':
            return 'rgba(64, 179, 29, 0.7)'
          case 'in POL terminal':
            return 'rgba(0, 191, 159, 0.7)'
          case 'waiting for departure from POL':
            return 'rgba(0, 195, 255, 0.7)'
          case 'ocean transport from POL':
            return 'rgba(13, 70, 191, 0.7)'
          case 'in transshipment':
            return 'rgba(43, 0, 107, 0.7)'
          case 'ocean transport to POD':
            return 'rgba(164, 0, 219, 0.7)'
          case 'waiting for discharge at POD':
            return 'rgba(250, 0, 225, 0.7)'
          case 'in POD terminal':
            return 'rgba(194, 0, 107, 0.7)'
          case 'land transport to Place of Delivery':
            return 'rgba(130, 22, 28, 0.7)'
          case 'delivered; returning container':
            return 'rgba(255, 118, 20, 0.7)'
          case 'completed':
            return 'rgba(224, 174, 22, 0.7)'
          default:
            return 'rgba(0, 156, 149, 0.6)'
        }
      }
    },
    prepareData (data) {
      if (!data || !data.data) return
      var container = document.getElementById('chart-container' + this.index)
      if (this.myChart) {
        this.myChart.destroy()
      }
      container.removeChild(document.getElementById('myChart' + this.index))
      var canvas = document.createElement('canvas')
      canvas.setAttribute('id', 'myChart' + this.index)
      canvas.setAttribute('width', '20')
      canvas.setAttribute('height', this.height)
      container.appendChild(canvas)
      var datasets = []
      Object.keys(data.data).forEach(dataKey => {
        if (!this.hideTotal || dataKey !== 'total') {
          datasets.push(
            {
              label: dataKey,
              data: data.data[dataKey],
              backgroundColor: 'rgba(186, 200, 200, 0.1)',
              borderColor: this.getColor(dataKey),
              borderWidth: 3
            }
          )
        }
      })
      if (datasets.length > 1) {
        Chart.defaults.global.plugins.datalabels.display = false
      } else {
        Chart.defaults.global.plugins.datalabels.display = true
      }
      return {labels: data.labels, datasets: datasets}
    },
    initChart (data) {
      this.ctx = document.getElementById('myChart' + this.index).getContext('2d')
      this.myChart = new Chart(this.ctx, {
        responsive: true,
        maintainAspectRatio: false,
        type: 'horizontalBar',
        data: data,
        options: {
          tooltips: {
            callbacks: {
              afterTitle: (tooltipItem, data) => {
                if (this.hideTotal) {
                  var title = 'Total: ' + (this.data.data.total[tooltipItem[0].index] * 1).toString() // this line removes unwanted decimals
                }
                return title
              }
            }
          },
          onClick: this.clickFunction,
          layout: {
            padding: {
              left: 0,
              right: 50,
              top: 0,
              bottom: 30
            }
          },
          scales: {
            yAxes: [{
              stacked: true,
              gridLines: {
                display: false
              },
              ticks: {
                beginAtZero: true,
                fontFamily: 'Courier New',
                callback: function (label) {
                  if (label && label.length > 13) {
                    return label.substring(0, 12) + '…'
                  } else {
                    while (label.length < 13) {
                      label += ' '
                    }
                    return label
                  }
                }
              }
            }],
            xAxes: [{
              stacked: !this.isNotStacked,
              gridLines: {
                display: true,
                zeroLineWidth: 2,
                lineWidth: 0,
                zeroLineColor: '#777788'
              },
              ticks: {
                display: false,
                max: this.maxValue ? this.maxValue : undefined,
                beginAtZero: true
              }
            }]
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/BarChar.vue